import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      !_vm.isModal
        ? [
            _c("div", { staticClass: "display-1" }, [_vm._v("Ver Videos")]),
            _c(VBreadcrumbs, {
              staticClass: "pa-0 py-2",
              attrs: { items: _vm.breadcrumbs },
            }),
            _c(
              VCard,
              { staticClass: "mt-2 pb-3 pr-3" },
              [
                _c(
                  VTabs,
                  {
                    attrs: { vertical: "" },
                    model: {
                      value: _vm.tab,
                      callback: function ($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab",
                    },
                  },
                  [
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(0)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.data_platform")))]
                    ),
                    _c(
                      VTabItem,
                      [
                        _c("ListVideos", {
                          attrs: {
                            videos: _vm.videos,
                            modulevid: "data_platform",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.audience")))]
                    ),
                    _c(
                      VTabItem,
                      [
                        _c("ListVideos", {
                          attrs: { videos: _vm.videos, modulevid: "audience" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(2)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.attributes")))]
                    ),
                    _c(
                      VTabItem,
                      [
                        _c("ListVideos", {
                          attrs: {
                            videos: _vm.videos,
                            modulevid: "attributes",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(3)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.customer_insights")))]
                    ),
                    _c(
                      VTabItem,
                      [
                        _c("ListVideos", {
                          attrs: {
                            videos: _vm.videos,
                            modulevid: "customer_insights",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(4)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.analytic_services")))]
                    ),
                    _c(
                      VTabItem,
                      [
                        _c("ListVideos", {
                          attrs: {
                            videos: _vm.videos,
                            modulevid: "analytic_services",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VTab,
                      {
                        on: {
                          click: function ($event) {
                            return _vm.sendtoGA(5)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("menu.chatbot_platform")))]
                    ),
                    _c(
                      VTabItem,
                      [
                        _c("ListVideos", {
                          attrs: {
                            videos: _vm.videos,
                            modulevid: "chatbot_platform",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : [
            _c(
              VTabs,
              {
                attrs: { vertical: "" },
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(0)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("menu.data_platform")))]
                ),
                _c(
                  VTabItem,
                  [
                    _c("ListVideos", {
                      attrs: { videos: _vm.videos, modulevid: "data_platform" },
                    }),
                  ],
                  1
                ),
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(1)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("menu.audience")))]
                ),
                _c(
                  VTabItem,
                  [
                    _c("ListVideos", {
                      attrs: { videos: _vm.videos, modulevid: "audience" },
                    }),
                  ],
                  1
                ),
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(2)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("menu.attributes")))]
                ),
                _c(
                  VTabItem,
                  [
                    _c("ListVideos", {
                      attrs: { videos: _vm.videos, modulevid: "attributes" },
                    }),
                  ],
                  1
                ),
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(3)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("menu.customer_insights")))]
                ),
                _c(
                  VTabItem,
                  [
                    _c("ListVideos", {
                      attrs: {
                        videos: _vm.videos,
                        modulevid: "customer_insights",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(4)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("menu.analytic_services")))]
                ),
                _c(
                  VTabItem,
                  [
                    _c("ListVideos", {
                      attrs: {
                        videos: _vm.videos,
                        modulevid: "analytic_services",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  VTab,
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sendtoGA(5)
                      },
                    },
                  },
                  [
                    _vm._v(_vm._s(_vm.$t("menu.chatbot_platform"))),
                    _c(
                      VTabItem,
                      [
                        _c("ListVideos", {
                          attrs: {
                            videos: _vm.videos,
                            modulevid: "chatbot_platform",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
      _c(
        "DialogsComponent",
        {
          ref: _vm.DIALOG_VIDEO,
          attrs: { title: _vm.actualVideo.titulo, width: 1000 },
        },
        [
          _c("template", { slot: "body" }, [
            _c("iframe", {
              attrs: { src: _vm.actualVideo.link, frameborder: "0" },
            }),
            _c("span", [_vm._v(_vm._s(_vm.actualVideo.description) + " ")]),
          ]),
        ],
        2
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "1000px" },
          model: {
            value: _vm.dialogFlag,
            callback: function ($$v) {
              _vm.dialogFlag = $$v
            },
            expression: "dialogFlag",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                { staticStyle: { padding: "0px" } },
                [
                  _vm._v(_vm._s(_vm.actualVideo.titulo)),
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { large: "", icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogFlag = false
                        },
                      },
                    },
                    [_c(VIcon, [_vm._v("icon-decline ")])],
                    1
                  ),
                ],
                1
              ),
              _vm.dialogFlag
                ? _c(VCardText, [
                    _c("iframe", {
                      attrs: {
                        width: "950",
                        height: "500",
                        src: _vm.actualVideo.link,
                        frameborder: "0",
                      },
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.actualVideo.description))]),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }